import { useState, useEffect } from 'react';
import { useTheme } from '../../context/theme';
import { renderIcon } from '../../utils/icons';

function formatTimeAgo(ts) {
  if (!ts) return '';
  const s = Math.floor((Date.now() - new Date(ts).getTime()) / 1000);
  if (s < 10) return 'just now';
  if (s < 60) return s + 's ago';
  if (s < 3600) return Math.floor(s / 60) + 'm ago';
  return Math.floor(s / 3600) + 'h ago';
}

export function AutoRefreshIndicator({ lastUpdated, isRefreshing, onRefresh, dataChanged, compact }) {
  const { theme, isDark } = useTheme();
  const [displayTime, setDisplayTime] = useState('');

  useEffect(() => {
    const update = () => setDisplayTime(formatTimeAgo(lastUpdated));
    update();
    const iv = setInterval(update, 10000);
    return () => clearInterval(iv);
  }, [lastUpdated]);

  if (!lastUpdated && !isRefreshing) return null;

  const prefersReducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  return (
    <div
      className={(dataChanged && !prefersReducedMotion) ? 'refresh-pulse' : ''}
      style={{
        display: 'inline-flex', alignItems: 'center', gap: compact ? 4 : 6,
        fontSize: compact ? 11 : 12, color: theme.textMuted,
        padding: compact ? '2px 6px' : '3px 8px',
        background: isDark ? 'rgba(255,255,255,0.04)' : 'rgba(0,0,0,0.04)',
        borderRadius: 6, transition: 'all 0.2s',
        border: `1px solid ${isDark ? 'rgba(255,255,255,0.06)' : 'rgba(0,0,0,0.06)'}`,
      }}
    >
      {isRefreshing && (
        <span className="refresh-spinner" style={{ display: 'inline-block', width: compact ? 10 : 12, height: compact ? 10 : 12, fontSize: compact ? 10 : 12, lineHeight: 1 }}>
          ⟳
        </span>
      )}
      {!isRefreshing && displayTime && <span>{displayTime}</span>}
      <button
        onClick={(e) => { e.stopPropagation(); onRefresh && onRefresh(); }}
        title="Refresh now"
        style={{
          background: 'none', border: 'none', cursor: 'pointer', padding: '0 2px',
          color: theme.textMuted, fontSize: compact ? 12 : 13, lineHeight: 1,
          opacity: isRefreshing ? 0.5 : 0.7, transition: 'opacity 0.15s',
        }}
        onMouseEnter={e => { e.currentTarget.style.opacity = '1'; }}
        onMouseLeave={e => { e.currentTarget.style.opacity = '0.7'; }}
      >
        {renderIcon('loader', 14)}
      </button>
    </div>
  );
}

export default AutoRefreshIndicator;
